import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import cx from 'classnames';
import BEMHelper from 'react-bem-helper';
import { Header, Segment } from 'semantic-ui-react';
import {
  getUserHasPlan,
  getUserSubscription,
} from '../../../../reducers/session/selectors';

import SettingsProperty from '../../SettingsProperty';

import './BillingBlock.scss';

const bem = BEMHelper({ name: 'SettingsBillingBlock', outputIsString: true });

function NewBillingBlock(props) {
  const {
    newPlatform,
    nextBillingAt: legacyNextBillingAt,
    billingPeriodUnit,
    billingPeriod: legacBillingPeriod,
    hasPlan,
  } = props;

  let nextBillingAt =
    (newPlatform &&
      newPlatform.subscription &&
      newPlatform.subscription.current_period_end) ||
    '';
  let billingPeriod =
    (newPlatform &&
      newPlatform.subscription &&
      newPlatform.subscription.pricing_plan &&
      newPlatform.subscription.pricing_plan.plan_type) ||
    '';

  let usingLegacy = false;

  if (legacyNextBillingAt && hasPlan) {
    if (moment(nextBillingAt).isBefore(legacyNextBillingAt) || !nextBillingAt) {
      nextBillingAt = legacyNextBillingAt;
      billingPeriod = legacBillingPeriod;
      usingLegacy = true;
    }
  }

  if (!nextBillingAt) return null;

  return (
    <Segment fluid className={cx('settings-block', bem())}>
      <Header as="h2" className="settings-block-title">
        Billing
      </Header>
      <SettingsProperty
        name="Next Billing On"
        value={nextBillingAt && moment(nextBillingAt).format('MMM D, YYYY')}
      />
      <SettingsProperty
        name="Billing Period"
        value={
          usingLegacy
            ? billingPeriod > 1
              ? `Every ${billingPeriod} ${billingPeriodUnit}s`
              : `Every ${billingPeriodUnit}`
            : billingPeriod &&
              billingPeriod.slice(0, 1).toUpperCase() +
                billingPeriod.slice(1).toLowerCase()
        }
      />
    </Segment>
  );
}

NewBillingBlock.propTypes = {
  newPlatform: PropTypes.shape({
    purchases: PropTypes.array,
    subscription: PropTypes.shape({
      current_period_end: PropTypes.string,
      pricing_plan: PropTypes.shape({
        plan_type: PropTypes.string,
      }),
    }),
  }),
  billingPeriod: PropTypes.string,
  nextBillingAt: PropTypes.string,
  billingPeriodUnit: PropTypes.string,
  hasPlan: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const subscription = getUserSubscription(state) || {};
  const hasPlan = getUserHasPlan(state);

  return {
    hasPlan,
    billingPeriod: subscription.billingPeriod,
    billingPeriodUnit: subscription.billingPeriodUnit,
    nextBillingAt: subscription.nextBillingAt,
    newPlatform: state.newPlatform,
  };
};

export default connect(mapStateToProps)(NewBillingBlock);
